import React, { useState, useEffect } from "react";
import { Button, Popover, Radio, Space, Typography } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import filtersIcon from "../../assets/icons/filtersIcon.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchEmployeeType,
  fetchContractType,
  FetchJobtypes,
  FetchRoleModuleAccess,
} from "../../redux/actions/action";

import "../../assets/styles/local/profile.css";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./index.module.css";
import { ButtonGroup, Button as MuiButton } from "@mui/material";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const { Text } = Typography;

const EmployeeFilter = ({ onSubmit, alwaysVisible }) => {
  const dispatch = useDispatch();
  const { employeeType, contractType } = useSelector((state) => state.user);
  const jobTypes = useSelector((state) => state.user.FetchJobtypes?.data?.data);
  const [visible, setVisible] = useState(false);
  const [allFunctions, setAllFunctions] = useState([]);
  const [allType, setAllType] = useState([]);
  const [allStatus, setAllStatus] = useState([]);
  const roleid = window.localStorage.getItem("roleid");
  const [fetchTransCoWorkersList, setFetchTransCoWorkersList] = useState({});
  const t = (key) => fetchTransCoWorkersList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Co-Workers-List").then((res) => {
      setFetchTransCoWorkersList(res);
    });
    dispatch(FetchRoleModuleAccess(roleid));
  }, []);

  const [activeFilters, setActiveFilters] = useState({
    function: false,
    employeeType: false,
    status: false,
    all: true,
  });

  useEffect(() => {
    dispatch(FetchJobtypes());
    // dispatch(fetchContractType());
    dispatch(fetchEmployeeType());
  }, []);

  const statusOptions = [
    { statusLabel: "Active", value: "1" },
    { statusLabel: "Pending", value: "2" },
    { statusLabel: "Non Active", value: "3" },
    { statusLabel: "Hired", value: "4" },
    { statusLabel: "Requested", value: "5" },
  ];

  useEffect(() => {
    if (
      jobTypes &&
      jobTypes.length > 0 &&
      employeeType &&
      employeeType.length > 0 &&
      allFunctions.length === 0 &&
      allType.length === 0 &&
      allStatus &&
      allStatus.length === 0
    ) {
      setAllFunctions(
        jobTypes.map((job) => {
          return { ...job, value: false };
        })
      );
      setAllType(
        employeeType.map((employee) => {
          return { ...employee, value: false };
        })
      );
      setAllStatus(
        statusOptions.map((status) => {
          return { ...status, value: false };
        })
      );
    }
  }, [jobTypes, employeeType, statusOptions]);

  const handleClear = () => {
    setActiveFilters({
      function: false,
      employeeType: false,
      status: false,
      all: true,
    });
    onSubmit("all");
    setVisible(false);

    // clear all filter options below
    setAllFunctions((prev) => prev.map((item) => ({ ...item, value: false })));
    setAllType((prev) => prev.map((item) => ({ ...item, value: false })));
    setAllStatus((prev) => prev.map((item) => ({ ...item, value: false })));
  };

  const handleSubmit = () => {
    if (activeFilters.function) {
      const arr = allFunctions.filter((func) => func.value);
      onSubmit(arr);
    } else if (activeFilters.employeeType) {
      const arr = allType.filter((func) => func.value);
      onSubmit(arr);
    } else if (activeFilters.status) {
      const arr = allStatus.filter((func) => func.value);
      onSubmit(arr);
    } else onSubmit("all");
    setVisible(false);
  };

  const content = (
    <div className="w-64">
      <div className="space-y-4">
        {/* Function Filter */}
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              gap: "5px",
            }}
          >
            <input
              type="checkbox"
              checked={activeFilters.all}
              className="form-check-input pointer companyRadio ms-"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "1rem",
              }}
              //   value={job.jobtypeid}
              onChange={() => {
                const existing = {
                  function: false,
                  employeeType: false,
                  status: false,
                  all: false,
                };
                existing["all"] = !activeFilters["all"];
                setActiveFilters(existing);
              }}
            />
            <Text strong className="block mb-2">
              All
            </Text>
          </div>
        </div>
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              gap: "5px",
            }}
          >
            <input
              type="checkbox"
              checked={activeFilters.function}
              className="form-check-input pointer companyRadio ms-"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "1rem",
              }}
              //   value={job.jobtypeid}
              onChange={() => {
                const existing = {
                  function: false,
                  employeeType: false,
                  status: false,
                  all: false,
                };
                existing["function"] = !activeFilters["function"];
                if (!existing["function"]) {
                  setAllFunctions((prev) =>
                    prev.map((func) => {
                      return { ...func, value: false };
                    }),
                  );
                }

                setActiveFilters(existing);
              }}
            />
            <Text strong className="block mb-2">
              Function
            </Text>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "5px",
            }}
          >
            {activeFilters.function &&
              allFunctions &&
              allFunctions.length > 0 &&
              allFunctions.map((job, index) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                      gap: "5px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={job.value}
                      className="form-check-input pointer companyRadio ms-"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "1rem",
                        borderRadius: "50%",
                      }}
                      onChange={() => {
                        const existing = [...allFunctions];
                        existing[index]["value"] = !existing[index]["value"];
                        setAllFunctions(existing);
                      }}
                    />
                    <div style={{ fontSize: 13 }}>{job.jobtypename}</div>
                  </div>
                );
              })}
          </div>
        </div>

        {/* Employee Type Filter */}
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              gap: "5px",
            }}
          >
            <input
              type="checkbox"
              checked={activeFilters.employeeType}
              className="form-check-input pointer companyRadio ms-"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "1rem",
              }}
              //   value={job.jobtypeid}
              onChange={() => {
                const existing = {
                  function: false,
                  employeeType: false,
                  status: false,
                  all: false,
                };
                existing["employeeType"] = !activeFilters["employeeType"];
                if (!existing["employeeType"]) {
                  setAllType((prev) =>
                    prev.map((func) => {
                      return { ...func, value: false };
                    }),
                  );
                }
                setActiveFilters(existing);
              }}
            />
            <Text strong className="block mb-2">
              Type of employee
            </Text>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "5px",
            }}
          >
            {activeFilters.employeeType &&
              allType &&
              allType.length > 0 &&
              allType
                .filter((job) => job.employeeTypeName !== null)
                .map((job, index) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        gap: "5px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={job.value}
                        className="form-check-input pointer companyRadio ms-"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginLeft: "1rem",
                          borderRadius: "50%",
                        }}
                        onChange={() => {
                          const existing = [...allType];
                          existing[index]["value"] = !existing[index]["value"];
                          setAllType(existing);
                        }}
                      />
                      <div style={{ fontSize: 13 }}>{job.employeeTypeName}</div>
                    </div>
                  );
                })}
          </div>
        </div>

        {/* Status Filter */}
        <div className="">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              gap: "5px",
            }}
          >
            <input
              type="checkbox"
              checked={activeFilters.status}
              className="form-check-input pointer companyRadio ms-"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "1rem",
              }}
              //   value={job.jobtypeid}
              onChange={() => {
                const existing = {
                  function: false,
                  employeeType: false,
                  status: false,
                  all: false,
                };
                existing["status"] = !activeFilters["status"];
                if (!existing["status"]) {
                  setAllStatus((prev) =>
                    prev.map((status) => {
                      return { ...status, value: false };
                    }),
                  );
                }
                setActiveFilters(existing);
              }}
            />
            <Text strong className="block mb-2">
              Status
            </Text>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "5px",
            }}
          >
            {activeFilters.status &&
              allStatus &&
              allStatus.length > 0 &&
              allStatus
                .filter((x) => x.statusLabel !== null)
                .map((item, index) => {
                  // console.log("asc34",job)
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        gap: "5px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={item.value}
                        className="form-check-input pointer companyRadio ms-"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginLeft: "1rem",
                          borderRadius: "50%",
                        }}
                        onChange={() => {
                          const existing = [...allStatus];
                          existing[index]["value"] = !existing[index]["value"];
                          setAllStatus(existing);
                        }}
                      />
                      <div style={{ fontSize: 13 }}>{item.statusLabel}</div>
                    </div>
                  );
                })}
          </div>
        </div>

        <div className="pt-4 border-t">
          <Button
            onClick={handleSubmit}
            className="w-full "
            style={{
              backgroundColor: "#00246a",
              color: "white",
              marginRight: "10px",
            }}
          >
            {/* Submit */}
            {t("Submit")}
          </Button>
          <Button onClick={handleClear} className="w-full">
            {/* Clear */}
            {t("Clear")}
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles.filterContainer}>
      <Popover
        content={content}
        trigger="click"
        open={visible}
        onOpenChange={setVisible}
        placement="bottomLeft"
        arrow={false}
      >
        <Button
          className={`flex items-center ${
            Object.values(activeFilters).some((v) => v) ? "bg-blue-50" : ""
          }`}
        >
          {/* Filters */}
          {t("Filters")}
          <img src={filtersIcon} alt="" style={{ height: 14, width: 14 }} />
        </Button>
      </Popover>
      {Object.values(activeFilters).some((filter) => filter) && (
        <ButtonGroup
          variant="outlined"
          aria-label="Basic button group"
          size="small"
          // className={styles.selectedFilter}
        >
          <MuiButton variant="outlined" className={styles.muibutton}>
            {activeFilters.all
              ? "All"
              : activeFilters.function
                ? "Function"
                : activeFilters.employeeType
                  ? "Type of employee"
                  : activeFilters.status
                    ? "Status"
                    : ""}
          </MuiButton>
          <MuiButton
            className={styles.muibutton}
            onClick={() => {
              setVisible(false);
              setActiveFilters({
                function: false,
                employeeType: false,
                status: false,
                all: alwaysVisible,
              });
              onSubmit("all");
            }}
          >
            <CloseIcon sx={{ height: 14, width: 14 }} />
          </MuiButton>
        </ButtonGroup>
      )}
    </div>
  );
};

export default EmployeeFilter;
